import { StyledSelect, StyledOption } from "./BlockUser.styled";
import AccountBannerImage from "../../assets/images/account-banner.png"
import ProfileImage from "../../assets/images/profile-icon.png"
import { useEffect, useState } from "react";

interface Props {
    id: string
    blocked: boolean
    handleChangeBlock: (id: string, blocked: boolean) => void
}

export const BlockUser = (props: Props) => {
    const [selectedRole, setSelectedRole] = useState<boolean>(props.blocked)
    const handleChange = () => {
        setSelectedRole(!selectedRole);
        props.handleChangeBlock(props.id, !selectedRole);
    }

    useEffect(() => {
        setSelectedRole(props.blocked);
    }, [props])
    return (
        <input type="checkbox" checked={selectedRole} onChange={handleChange} />
    );
};